export default {
    "01": "Stockholms län",
    "0114": "Upplands Väsby",
    "0115": "Vallentuna",
    "0117": "Österåker",
    "0120": "Värmdö",
    "0123": "Järfälla",
    "0125": "Ekerö",
    "0126": "Huddinge",
    "0127": "Botkyrka",
    "0128": "Salem",
    "0136": "Haninge",
    "0138": "Tyresö",
    "0139": "Upplands-Bro",
    "0140": "Nykvarn",
    "0160": "Täby",
    "0162": "Danderyd",
    "0163": "Sollentuna",
    "0180": "Stockholm",
    "0181": "Södertälje",
    "0182": "Nacka",
    "0183": "Sundbyberg",
    "0184": "Solna",
    "0186": "Lidingö",
    "0187": "Vaxholm",
    "0188": "Norrtälje",
    "0191": "Sigtuna",
    "0192": "Nynäshamn",
    "03": "Uppsala län",
    "0305": "Håbo",
    "0319": "Älvkarleby",
    "0330": "Knivsta",
    "0331": "Heby",
    "0360": "Tierp",
    "0380": "Uppsala",
    "0381": "Enköping",
    "0382": "Östhammar",
    "04": "Södermanlands län",
    "0428": "Vingåker",
    "0461": "Gnesta",
    "0480": "Nyköping",
    "0481": "Oxelösund",
    "0482": "Flen",
    "0483": "Katrineholm",
    "0484": "Eskilstuna",
    "0486": "Strängnäs",
    "0488": "Trosa",
    "05": "Östergötlands län",
    "0509": "Ödeshög",
    "0512": "Ydre",
    "0513": "Kinda",
    "0560": "Boxholm",
    "0561": "Åtvidaberg",
    "0562": "Finspång",
    "0563": "Valdemarsvik",
    "0580": "Linköping",
    "0581": "Norrköping",
    "0582": "Söderköping",
    "0583": "Motala",
    "0584": "Vadstena",
    "0586": "Mjölby",
    "06": "Jönköpings län",
    "0604": "Aneby",
    "0617": "Gnosjö",
    "0642": "Mullsjö",
    "0643": "Habo",
    "0662": "Gislaved",
    "0665": "Vaggeryd",
    "0680": "Jönköping",
    "0682": "Nässjö",
    "0683": "Värnamo",
    "0684": "Sävsjö",
    "0685": "Vetlanda",
    "0686": "Eksjö",
    "0687": "Tranås",
    "07": "Kronobergs län",
    "0760": "Uppvidinge",
    "0761": "Lessebo",
    "0763": "Tingsryd",
    "0764": "Alvesta",
    "0765": "Älmhult",
    "0767": "Markaryd",
    "0780": "Växjö",
    "0781": "Ljungby",
    "08": "Kalmar län",
    "0821": "Högsby",
    "0834": "Torsås",
    "0840": "Mörbylånga",
    "0860": "Hultsfred",
    "0861": "Mönsterås",
    "0862": "Emmaboda",
    "0880": "Kalmar",
    "0881": "Nybro",
    "0882": "Oskarshamn",
    "0883": "Västervik",
    "0884": "Vimmerby",
    "0885": "Borgholm",
    "09": "Gotlands län",
    "0980": "Gotland",
    "10": "Blekinge län",
    "1060": "Olofström",
    "1080": "Karlskrona",
    "1081": "Ronneby",
    "1082": "Karlshamn",
    "1083": "Sölvesborg",
    "12": "Skåne län",
    "1214": "Svalöv",
    "1230": "Staffanstorp",
    "1231": "Burlöv",
    "1233": "Vellinge",
    "1256": "Östra Göinge",
    "1257": "Örkelljunga",
    "1260": "Bjuv",
    "1261": "Kävlinge",
    "1262": "Lomma",
    "1263": "Svedala",
    "1264": "Skurup",
    "1265": "Sjöbo",
    "1266": "Hörby",
    "1267": "Höör",
    "1270": "Tomelilla",
    "1272": "Bromölla",
    "1273": "Osby",
    "1275": "Perstorp",
    "1276": "Klippan",
    "1277": "Åstorp",
    "1278": "Båstad",
    "1280": "Malmö",
    "1281": "Lund",
    "1282": "Landskrona",
    "1283": "Helsingborg",
    "1284": "Höganäs",
    "1285": "Eslöv",
    "1286": "Ystad",
    "1287": "Trelleborg",
    "1290": "Kristianstad",
    "1291": "Simrishamn",
    "1292": "Ängelholm",
    "1293": "Hässleholm",
    "13": "Hallands län",
    "1315": "Hylte",
    "1380": "Halmstad",
    "1381": "Laholm",
    "1382": "Falkenberg",
    "1383": "Varberg",
    "1384": "Kungsbacka",
    "14": "Västra Götalands län",
    "1401": "Härryda",
    "1402": "Partille",
    "1407": "Öckerö",
    "1415": "Stenungsund",
    "1419": "Tjörn",
    "1421": "Orust",
    "1427": "Sotenäs",
    "1430": "Munkedal",
    "1435": "Tanum",
    "1438": "Dals-Ed",
    "1439": "Färgelanda",
    "1440": "Ale",
    "1441": "Lerum",
    "1442": "Vårgårda",
    "1443": "Bollebygd",
    "1444": "Grästorp",
    "1445": "Essunga",
    "1446": "Karlsborg",
    "1447": "Gullspång",
    "1452": "Tranemo",
    "1460": "Bengtsfors",
    "1461": "Mellerud",
    "1462": "Lilla Edet",
    "1463": "Mark",
    "1465": "Svenljunga",
    "1466": "Herrljunga",
    "1470": "Vara",
    "1471": "Götene",
    "1472": "Tibro",
    "1473": "Töreboda",
    "1480": "Göteborg",
    "1481": "Mölndal",
    "1482": "Kungälv",
    "1484": "Lysekil",
    "1485": "Uddevalla",
    "1486": "Strömstad",
    "1487": "Vänersborg",
    "1488": "Trollhättan",
    "1489": "Alingsås",
    "1490": "Borås",
    "1491": "Ulricehamn",
    "1492": "Åmål",
    "1493": "Mariestad",
    "1494": "Lidköping",
    "1495": "Skara",
    "1496": "Skövde",
    "1497": "Hjo",
    "1498": "Tidaholm",
    "1499": "Falköping",
    "17": "Värmlands län",
    "1715": "Kil",
    "1730": "Eda",
    "1737": "Torsby",
    "1760": "Storfors",
    "1761": "Hammarö",
    "1762": "Munkfors",
    "1763": "Forshaga",
    "1764": "Grums",
    "1765": "Årjäng",
    "1766": "Sunne",
    "1780": "Karlstad",
    "1781": "Kristinehamn",
    "1782": "Filipstad",
    "1783": "Hagfors",
    "1784": "Arvika",
    "1785": "Säffle",
    "18": "Örebro län",
    "1814": "Lekeberg",
    "1860": "Laxå",
    "1861": "Hallsberg",
    "1862": "Degerfors",
    "1863": "Hällefors",
    "1864": "Ljusnarsberg",
    "1880": "Örebro",
    "1881": "Kumla",
    "1882": "Askersund",
    "1883": "Karlskoga",
    "1884": "Nora",
    "1885": "Lindesberg",
    "19": "Västmanlands län",
    "1904": "Skinnskatteberg",
    "1907": "Surahammar",
    "1960": "Kungsör",
    "1961": "Hallstahammar",
    "1962": "Norberg",
    "1980": "Västerås",
    "1981": "Sala",
    "1982": "Fagersta",
    "1983": "Köping",
    "1984": "Arboga",
    "20": "Dalarnas län",
    "2021": "Vansbro",
    "2023": "Malung-Sälen",
    "2026": "Gagnef",
    "2029": "Leksand",
    "2031": "Rättvik",
    "2034": "Orsa",
    "2039": "Älvdalen",
    "2061": "Smedjebacken",
    "2062": "Mora",
    "2080": "Falun",
    "2081": "Borlänge",
    "2082": "Säter",
    "2083": "Hedemora",
    "2084": "Avesta",
    "2085": "Ludvika",
    "21": "Gävleborgs län",
    "2101": "Ockelbo",
    "2104": "Hofors",
    "2121": "Ovanåker",
    "2132": "Nordanstig",
    "2161": "Ljusdal",
    "2180": "Gävle",
    "2181": "Sandviken",
    "2182": "Söderhamn",
    "2183": "Bollnäs",
    "2184": "Hudiksvall",
    "22": "Västernorrlands län",
    "2260": "Ånge",
    "2262": "Timrå",
    "2280": "Härnösand",
    "2281": "Sundsvall",
    "2282": "Kramfors",
    "2283": "Sollefteå",
    "2284": "Örnsköldsvik",
    "23": "Jämtlands län",
    "2303": "Ragunda",
    "2305": "Bräcke",
    "2309": "Krokom",
    "2313": "Strömsund",
    "2321": "Åre",
    "2326": "Berg",
    "2361": "Härjedalen",
    "2380": "Östersund",
    "24": "Västerbottens län",
    "2401": "Nordmaling",
    "2403": "Bjurholm",
    "2404": "Vindeln",
    "2409": "Robertsfors",
    "2417": "Norsjö",
    "2418": "Malå",
    "2421": "Storuman",
    "2422": "Sorsele",
    "2425": "Dorotea",
    "2460": "Vännäs",
    "2462": "Vilhelmina",
    "2463": "Åsele",
    "2480": "Umeå",
    "2481": "Lycksele",
    "2482": "Skellefteå",
    "25": "Norrbottens län",
    "2505": "Arvidsjaur",
    "2506": "Arjeplog",
    "2510": "Jokkmokk",
    "2513": "Överkalix",
    "2514": "Kalix",
    "2518": "Övertorneå",
    "2521": "Pajala",
    "2523": "Gällivare",
    "2560": "Älvsbyn",
    "2580": "Luleå",
    "2581": "Piteå",
    "2582": "Boden",
    "2583": "Haparanda",
    "2584": "Kiruna",
}



// WEBPACK FOOTER //
// ./src/constants/kommuner.js